import React from "react";
import { LazyLoadImages } from "@quintype/components";
import { StoryFeedPage as StoryFeedPageBase } from "../components/pages/story/story-feed";
import { StoryPagePreview as StoryPagePreviewBase } from "../components/pages/story-preview";
import { StoryPageStatic as StoryPageStaticBase } from "../components/pages/story/static-page/story-static";
import { TopicsPage as TopicsPageBase } from "../components/pages/story/topics-page/topics-page";
import { Sitemap as SitemapBase } from "../components/pages/story/sitemap/sitemap";
import { RasipalanLandingPage as RasipalanLandingPageBase } from "../components/pages/rasipalan-landing";
import { GurupeyarchiLandingPage as GurupeyarchiLandingPageBase } from "../components/pages/gurupeyarchi-landing";
import { GurupeyarchiStoryPage as GurupeyarchiStoryPageBase } from "../components/pages/gurupeyarchi-story";
import { StoryGlancePage as StoryGlancePageeBase } from "../components/pages/story/story-feed-glance";
import HeaderAdUnit from "../components/atoms/header-ad-unit";

function wrapLazyLoadImages(Template, Ad = true) {
  const ImageLazyLoadedComponent = props => {
    return (
      <React.Fragment>
        <HeaderAdUnit />
        <LazyLoadImages margin={"150px"}>
          <Template {...props} />
        </LazyLoadImages>
      </React.Fragment>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const StoryPage = wrapLazyLoadImages(StoryFeedPageBase, false);
export const StoryPagePreview = wrapLazyLoadImages(StoryPagePreviewBase);
export const StoryPageStatic = wrapLazyLoadImages(StoryPageStaticBase);
export const TopicsPage = wrapLazyLoadImages(TopicsPageBase);
export const Sitemap = wrapLazyLoadImages(SitemapBase);
export const RasipalanLandingPage = wrapLazyLoadImages(RasipalanLandingPageBase);
export const GurupeyarchiLandingPage = wrapLazyLoadImages(GurupeyarchiLandingPageBase);
export const GurupeyarchiStoryPage = wrapLazyLoadImages(GurupeyarchiStoryPageBase);
export const StoryGlancePage = wrapLazyLoadImages(StoryGlancePageeBase, false);
